import React from 'react'
import { Link } from 'react-router-dom'

const CashZoneButton = ({ label, link_src, active, type, active_color, onClick }) => {
    return (
        <>
            {type === "link" ?
                <Link to={link_src} className={`${active ? `${active_color} lg:bg-deep-blue` : 'bg-[#555] lg:bg-dark-gradient'} hover:filter hover:brightness-[1.3] cursor-pointer text-sm font-bold h-[38px] leading-[38px] inline-block align-middle lg:rounded text-white transition-[0.2s] lg:shadow-[inset_0_1px_0px_0_rgba(255,255,255,0.3)] m-0.5 px-5 border-none`}>{label}</Link>
                :
                type === "button" ?
                    <button type='button' onClick={onClick} className={`${active ? `${active_color} lg:bg-deep-blue` : 'bg-[#555] lg:bg-dark-gradient'} hover:filter hover:brightness-[1.2] cursor-pointer text-sm font-bold h-[38px] leading-[38px] inline-block align-middle lg:rounded text-white transition-[0.2s] lg:shadow-[inset_0_1px_0px_0_rgba(255,255,255,0.3)] m-0.5 px-5 border-none`}>{label}</button>
                    :
                    <Link to={link_src} className={`${active ? 'bg-amberGold lg:bg-deep-blue' : 'bg-[#555] lg:bg-dark-gradient'} hover:filter hover:brightness-[1.3] cursor-pointer text-sm font-bold h-[38px] leading-[38px] inline-block align-middle lg:rounded text-white transition-[0.2s] lg:shadow-[inset_0_1px_0px_0_rgba(255,255,255,0.3)] m-0.5 px-5 border-none`}>{label}</Link>
            }
        </>
    )
}

export default CashZoneButton